<template>
  <footer>
    <div class="container">
      <div class="footer-nav">
        <div class="menu nav-menu">
          <ul>
            <li v-for="item,i in navItems"
                :key="i"
                @click="toLink(item.link, $event)">
              {{ item.text }}
            </li>
          </ul>
        </div>
      </div>
      <ul class="footer-links">

        <li>关于我们：</li>
        <li>
          <router-link to="/jobintro">企业介绍</router-link>
        </li>
        <li>
          <router-link to="/useragreement">用户协议</router-link>
        </li>
        <li>
          <router-link to="/privateagree">隐私协议</router-link>
        </li>
        <li><a href="">平台客服电话:<span class="phone">{{ phone }}</span></a></li>

      </ul>
      <div class="copyright">
        Copyright ©2023 上海星环琪迹网络科技有限公司 &nbsp;&nbsp;All Rights Reserved &nbsp;&nbsp;<a href="https://beian.miit.gov.cn/#/Integrated/index">ICP备案：沪ICP备2023020645号-1</a>
      </div>
    </div>

    <div class="fixed">
      <div class="close"
           @click="change">
        <img src="../assets/images/close_ico.png"
             alt="">
      </div>

      <ul>
        <li>
          <div class="img">
            <div class="bg">
              <img src="../assets/images/ewm_bg.png"
                   alt="">
            </div>

            <img src="../assets/images/ewm.png"
                 alt="">
          </div>
          <a href="">苹果APP下载</a>
        </li>
        <li>
          <div class="img">
            <div class="bg">
              <img src="../assets/images/ewm_bg.png"
                   alt="">
            </div>
            <img src="../assets/images/androidapp.png"
                 alt=""
                 v-viewer>

          </div>
          <a href="https://ringstar.xhqj71.com/jeecg-boot//sys/common/static/app_url/__UNI__3A20F3B_0408095550.apk">安卓APP下载</a>
        </li>
      </ul>
      <div class="fixedservice"
           @click="kefu"><img class="ser_ico"
             src="../assets/images/serve_ico.png"></div>

    </div>

  </footer>
</template>

<script>
// function  hide() {
//         var div = document.getElementById("close");
//         div.style.display = "none";
//       }
const navItems = [{
  text: '首页',
  link: '/'
}, {
  text: '圈子',
  link: '/about'
}, {
  text: '圈友',
  link: '/friend'
}, {
  text: '动态',
  link: '/moments'
}, {
  text: '企业',
  link: '/job'
}, {
  text: '询价',
  link: '/price'
}];

import {
  home,
  token,
  agree,
} from '../api/api';
import router from '../router';
export default {
  name: 'headers',
  data() {
    return {
      navItems: navItems,
      youid: "",
      phone: "",
    }
  },
  mounted() {
    this.gethome();
  },
  methods: {
    gethome() {
      home().then(res => {
        if (res.data.code == 200) {

          this.youid = res.data.result;
        }
      });
      agree({
        id: 1
      }).then(res => {
        if (res.data.code == 200) {

          this.phone = res.data.result.phone;
        }
      });

    },

    toLink(link, $event) {
      [].forEach.call(document.getElementsByTagName('li'), function (item) {
        item.className = ''
      });
      $event.target.className = 'selected';
      router.push(link || '/');
    },
    change() {
      var element = document.querySelector(".fixed");
      if (element.style.display === "none") {
        element.style.display = "block";
      } else {
        element.style.display = "none";
      }
    },
    kefu() {
      if (window.sessionStorage.token) {
        token().then(res => {
          if (res.data.code == 200) {

          }
        });
        this.$router.push({
          path: '/kefu',
          query: {
            id: this.youid
          }
        })
      } else {
        this.msg = "请先登录账号！"
        this.open();

      }
    },
    open() {
      this.$msgbox({
        title: "提示",
        message: `${this.msg}`,
        type: "warning",
        center: true,
        confirmButtonText: "确定"
      }).then(() => {

      });
    },
  }
}
</script>

<style lang="scss" scoped>
.ser_ico {
  background: white;
  border-radius: 50%;
  padding: 5px;
  cursor: pointer;
}

.phone {
  letter-spacing: 0.5px;
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue